// angular
// 	.module("HeroPRO")
// 	.controller("PipelineTableController", PipelineTableController);

import _ from 'lodash';

import './pipelineTable.scss';

/* @ngInject */
export default function PipelineTableController($scope, $state, $analytics, PipelineMappings, PipelineFactory, ProjectAdvanceFactory, ModalService, JobFactory) {
    const vm = this;
    vm.columns = PipelineMappings.columns;
    vm.data = [];
    vm.currentSort = {};
    vm.pipelineStageId = null;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.goToAppDetail = function (row) {
        if (row.PrequalId !== undefined) {
            $state.go('lead', {
                prequalId: row.PrequalId,
            });
        } else {
            $state.go('app-detail', {
                appId: row.FundingRequestId,
            });
        }
    };

    vm.goToLeadDetail = function (row) {
        $state.go('lead', {
            prequalId: row.PreQualId,
        });
    };

    vm.headerClick = function (column) {
        if (PipelineMappings.columns[column].sort === true) {
            if (vm.columns[column].apiColumnId === vm.currentSort.SortColumnId) {
                // Current column that we're sorting by was clicked, change sort order
                vm.currentSort.SortOrderID = (vm.currentSort.SortOrderID === 1) ? 2 : 1;
            } else {
                // Sort by a new column
                vm.currentSort.SortColumnId = vm.columns[column].apiColumnId;
                vm.currentSort.SortOrderID = 1;
            }

            PipelineFactory.setPipelineDataOptions({
                sortOptions: vm.currentSort,
            });
            $scope.$emit('sortClicked');
        }
    };

    vm.showExpirationPopover = function (pipelineEntry) {
        if ((pipelineEntry.PipelineStageId === 2 && pipelineEntry.daysToExpiration <= 10) ||
   ((pipelineEntry.PipelineStageId === 3 || pipelineEntry.PipelineStageId === 4) && pipelineEntry.daysToExpiration <= 30)) {
            return true;
        }
        return false;
    };

    vm.getExpirationMessage = function (pipelineEntry) {
        if (pipelineEntry.daysToExpiration <= 0) {
            return 'Expired';
        } else if (pipelineEntry.daysToExpiration === 1) {
            return 'Expiring in 1 day';
        }
        return `Expiring in ${pipelineEntry.daysToExpiration} days`;
    };

    vm.launchAssignJobModal = function (row, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        JobFactory.setActiveJob(row);
        JobFactory.setAssignJobFlag(true);

        $analytics.eventTrack('Open Assign Modal', {
            category: 'AssignJob',
            label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name,
        });

        ModalService.launchLgModal({
            templateUrl: 'app/pipeline/job/pipelineJobModal.html',
            windowClass: 'pipeline-job-modal',
            controller: 'PipelineJobModalController',
            controllerAs: 'pipelineJobModal',
        });
    };

    vm.launchHideJobModal = function (row, $event) {
        $event.preventDefault();
        $event.stopPropagation();
        JobFactory.setActiveJob(row);
        JobFactory.setAssignJobFlag(false);

        $analytics.eventTrack('Open Hide Modal', {
            category: 'HideAJob',
            label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name,
        });

        ModalService.launchLgModal({
            templateUrl: 'app/pipeline/job/pipelineJobModal.html',
            windowClass: 'pipeline-job-modal',
            controller: 'PipelineJobModalController',
            controllerAs: 'pipelineJobModal',
        });
    };

    vm.unhideJob = function (row, $event, undo) {
        $event.preventDefault();
        $event.stopPropagation();

        if (undo !== undefined && undo === true) {
            $analytics.eventTrack('Click Undo Button', {
                category: 'HideAJob',
                label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name,
            });
        } else {
            $analytics.eventTrack('Click UnHide Button', {
                category: 'HideAJob',
                label: PipelineFactory.getPipelineStages()[vm.pipelineStageId - 1].name,
            });
        }

        if (row.FundingRequestId !== undefined) {
            JobFactory.unhideApplication({
                FundingRequestId: row.FundingRequestId,
            }).then(() => {
                row.hidden.status = false;
                row.unhidden.status = true;
                row.unhidden.address = `${row.PropertyAddress1} ${row.PropertyCity}, ${row.PropertyState} ${row.PropertyZip}`;
            });
        } else if (row.PreQualId !== undefined) {
            JobFactory.unhideLead({
                PreQualId: row.PreQualId,
            }).then(() => {
                row.hidden.status = false;
                row.unhidden.status = true;
                row.unhidden.address = row.Address;
            });
        }
    };

    vm.jobActionsClick = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
    };

    // Track popover opening to change arrow direction
    vm.clickAdvPayPopover = function (row) {
        row.popoverOpen = !row.popoverOpen;
    };

    // Track popover opening to change arrow direction
    vm.clickProjAdvPopover = function (row) {
        ProjectAdvanceFactory.setActiveProjectAdvanceFundingRequestId({
            FundingRequestId: row.FundingRequestId,
        });
        row.paPopoverOpen = !row.paPopoverOpen;
    };

    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */
    function init() {
        $scope.$on('pipelineTableUpdate', handleNewPipelineData);
        $scope.$emit('pipelineTableReady');
        $scope.$on('pipelineJobAssignment', handleAssignment);
        $scope.$on('pipelineHideJob', handleHide);
    }

    function handleNewPipelineData(ev, data) {
        vm.pipelineStageId = data.pipelineStageId;
        vm.mappings = PipelineMappings.mappings[vm.pipelineStageId];
        vm.data = data.data;
        processPipelineData();
        setCurrentSortOptions(PipelineFactory.getPipelineDataOptions(), data.pipelineStageId);
    }

    function setCurrentSortOptions(sortOptions, pipelineStageId) {
        if (PipelineFactory.getPipelineDataOptions().sortOptions === undefined) {
            vm.currentSort.SortColumnId = (pipelineStageId === 5) ? 9 : 8; // 9 = FundDate, 8 = Date
            vm.currentSort.SortOrderID = 1; // 1 = Descending, 2 = Ascending
        } else {
            vm.currentSort.SortColumnId = sortOptions.sortOptions.SortColumnId;
            vm.currentSort.SortOrderID = sortOptions.sortOptions.SortOrderID;
        }
    }

    function processPipelineData() {
        _.each(vm.data, (pipelineEntry) => {
            // Set some defaults for each pipeline entry
            pipelineEntry.reassigned = {};
            pipelineEntry.reassigned.status = false;
            pipelineEntry.hidden = {};
            pipelineEntry.hidden.status = false;
            pipelineEntry.unhidden = {};
            pipelineEntry.unhidden.status = false;
            pipelineEntry.daysToExpiration = calculateExpirationDate(pipelineEntry);
            if (pipelineEntry.advancePaymentData !== undefined && pipelineEntry.advancePaymentData.APEligible === true) {
                pipelineEntry.popoverOpen = false;
            }
            if (pipelineEntry.projectAdvanceData !== undefined && pipelineEntry.projectAdvanceData !== null) {
                pipelineEntry.paPopoverOpen = false;
            }
        });
    }

    function calculateExpirationDate(pipelineEntry) {
        let expirationSource = null;

        if (pipelineEntry.PipelineStageId === 2 || pipelineEntry.PipelineStageId === 3 || pipelineEntry.PipelineStageId === 4) {
            expirationSource = 'LoanApprovedThroughDate';
        }

        if (expirationSource !== null) {
            const timeDiff = new Date(pipelineEntry[expirationSource]).getTime() - new Date().getTime();
            const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return daysDiff;
        }
        return 99; // Setting a large default
    }

    // (ajt 1/3/2016) - [HP-162] Added new subscriber method to handle job assignments based on Lead vs Application/Loan
    function handleAssignment(ev, data) {
        const assignedJob = data.data;
        if (assignedJob.PreQualId !== undefined && assignedJob.PreQualId !== null && assignedJob.PreQualId !== '') {
            for (let i = 0; i < vm.data.length; i++) {
                if (vm.data[i].PreQualId === assignedJob.PreQualId) {
                    vm.data[i].reassigned.status = true;
                    vm.data[i].reassigned.locationName = assignedJob.Location;
                    vm.data[i].reassigned.salesRepName = assignedJob.SalesRepName;
                }
            }
        } else {
            for (let j = 0; j < vm.data.length; j++) {
                if (vm.data[j].FundingRequestId === assignedJob.FundingRequestId) {
                    vm.data[j].reassigned.status = true;
                    vm.data[j].reassigned.locationName = assignedJob.Location;
                    vm.data[j].reassigned.salesRepName = assignedJob.SalesRepName;
                }
            }
        }
    }

    // (ajt 4/4/2016) - [HP-1179] Added new subscriber method to handle hiding jobs based on Lead vs Application/Loan
    function handleHide(ev, data) {
        const hiddenJob = data.data;
        if (hiddenJob.PreQualId !== undefined && hiddenJob.PreQualId !== null && hiddenJob.PreQualId !== '') {
            for (let i = 0; i < vm.data.length; i++) {
                if (vm.data[i].PreQualId === hiddenJob.PreQualId) {
                    vm.data[i].hidden.status = true;
                    vm.data[i].hidden.address = hiddenJob.Address;
                }
            }
        } else {
            for (let j = 0; j < vm.data.length; j++) {
                if (vm.data[j].FundingRequestId === hiddenJob.FundingRequestId) {
                    vm.data[j].hidden.status = true;
                    vm.data[j].hidden.address = hiddenJob.Address;
                }
            }
        }
    }

    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineTable/pipelineTableController.js